/* eslint-disable */
const MEETINGS = {
  JUN2025: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=9F57C5314BBB62CAF35BC39515C3EB0A&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa><pa%20pt="4"%20pin="0"%20did="89229A1E478528C5669C6A82E9A46114"%20tp="10">2025</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=BFD983A44A74865A4CC77BA740EBACE2&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=9CABBE5149A3C6F44761D6A314B860BE&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa></rsl>`,
    backlog: `http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/Backlog.pptx?web=1`,
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=664A5411435311EF771C4EA98EA2A89F&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=32DA6DF6476846F0EE91BEBE2746E393&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa><pa%20pt="4"%20pin="0"%20did="E416727E450700611122C5AE1240A9C4"%20tp="10">202505</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2025/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
  FEB2025: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=C8DA2A334FA40B156EB9A9B5DC813BF5&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=C9E6B8AD475FCBF53F4D089B6B8C2DC2&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=276F60944C3586B1BF8E5B93B09085D9&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa></rsl>`,
    backlog: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=3D6C9E35490C11752FAA02B924DCF99A&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa></rsl>`,
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=8E7411574194E065BE3F01B5B4C621EE&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="4DA222284D086415060FE88BFA641085"%20tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=7CF2F5C04D7507ECCDCA5F9BC7BDC0F6&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa%20pt="3"%20pin="0"%20did="0526CBDA4A4905B8C4874995B6DE8918"%20tp="10">{REGION}</pa><pa%20pt="3"%20pin="0"%20did="C00F8B74478126E3E8874BB2E8FC8FC0"%20tp="10">{COUNTRY}</pa><pa%20pt="4"%20pin="0"%20did="E416727E450700611122C5AE1240A9C4"%20tp="10">202501</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/FEB2025/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2025/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2025/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2025/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/FEB2025/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2025/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2025/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2025/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
  JUN2024: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=12D5377B41E649EB0C444FB599F26A96&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2024</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=A64D48ED4B993BD12CC8B88DE06EDBAC&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2024</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=C82BCFB7408F2E6D44A26F99187B02D7&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2024</pa></rsl>`,
    backlog: `http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/Backlog.pptx?web=1`,
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=A457D713449078F7E38C0ABE5001E1F3&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2024</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=FEE9A24541F39E12261BBEBCC738A80F&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2024</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2024/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
	MAR2024: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=29C1E7E04501E6E7E9250E9143E6736D&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=0896C5F942A57E8507BF9788B8EEEC45&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>	`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=ABF0605B4B4E2FC31F50149C9F0F63F3&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    backlog: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=23C64AC24EB28BA4B99C38B9EBBC57A8&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=53798060477A31A6012842873151802B&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=3890661B45DC8141D2CAA9845D9946FF&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202024/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202024/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202024/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202024/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202024/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202024/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202024/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202024/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
	JUN2023: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=F68E959042A30B3F77054E8530012C73&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=483B0C3441073B6D012889957F0ADE7B&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=348ADCDD445BFC9AC0F0058280296FAC&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    backlog: `http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/Backlog.pptx?web=1`,
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=2A9F096E4362C233A5AC79B88C842450&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=CBC06B4A474200EC71D92BBFDA235182&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">MAY 2023</pa><pa pt="3" pin="0" did="C00F8B74478126E3E8874BB2E8FC8FC0" tp="10">{COUNTRY}</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202023/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
  MAR2023: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=279BBB0A42CA76DFA9A3388455CB1AAF&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=20513BFD4644EDDCB31EECA4FA0787E6&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=D62834994CEAAD0FB7CBF9B2C708D6E9&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    backlog: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=D0614334426EB470C5D6E9810C668E44&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=1F5FDC83450F0D9877F05E9732003F16&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=EDA40F9340F40E97E83521BF51EC96D9&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2023</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202023/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202023/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202023/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202023/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202023/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202023/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202023/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/MAR%202023/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
  JUN2022: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=A33AD62A4ADFF66FEB1034AA8F2BD513&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=23693CCD4D03E49ED82D9781635D7FA6&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=F272707E4FA5482EF2A4AB81A1FF575A&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    backlog: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/Backlog.pptx?web=1",
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=F5D0F88448F3E9004DA9CB8CF840C4DE&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=4472090241B170BE382316AC30EA4D56&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">MAY 2022</pa><pa pt="3" pin="0" did="C00F8B74478126E3E8874BB2E8FC8FC0" tp="10">{COUNTRY}</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202022/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
  FEB2022: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=1A78F03E432346E54CB76295F1CA2A3B&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=F029C36F47D484037690E79BD37D202C&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=B0E68C814CD9F7C9B1A75787E61FEAF8&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    backlog: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=05FBC1C04AA978C80027AF8741FF73C7&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=7A804D0043DBC2E93DB118AF8B3B951F&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=8287539A4AAB153ADC8C10BABCC223D1&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">ENE 2022</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202022/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202022/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202022/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202022/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202022/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202022/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202022/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202022/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
  AGO2021: {
    pl: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=241846854DE0314AF5E43089CB362E70&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2021</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=89D254924410824FFAB61E94A114B513&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2021</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=FE3351464B19AEC694AA398E9DA31662&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2021</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    backlog: "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/Backlog.pptx?web=1",
    acquisitions: `https://mstrprd.teic.techint.net:443/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=7A123F8D4772AA5EC637BE8E144E2D87&currentViewMedia=1&visMode=0&Server=TEIUYWAS132&Project=Economics&Port=0&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2021</pa><pa pt="3" pin="0" did="4DA222284D086415060FE88BFA641085" tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=E47369F24CE7590B434B29BB66E8DF61&currentViewMedia=1&visMode=0&Server=TEIUYWAS132.TEIC.TECHINT.NET&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="C00F8B74478126E3E8874BB2E8FC8FC0" tp="10">{COUNTRY}</pa><pa pt="3" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">JUN 2021</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO%202021/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
  JUN2021: {
    pl: `https://mstrprd.teic.techint.net/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=22FA0B6C44AF2D6D7AA8B9BCE9A33B5A&currentViewMedia=1&visMode=0&Server=TEIUYWAS132.TEIC.TECHINT.NET&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2021</pa><pa pt="3" pin="0" did="C00F8B74478126E3E8874BB2E8FC8FC0" tp="10">{COUNTRY}</pa></rsl>`,
    revenue: `https://mstrprd.teic.techint.net/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=204AFBD440D4DA675EF7FFB4AD7EFE48&currentViewMedia=1&visMode=0&Server=TEIUYWAS132.TEIC.TECHINT.NET&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2021</pa><pa pt="3" pin="0" did="C00F8B74478126E3E8874BB2E8FC8FC0" tp="10">{COUNTRY}</pa></rsl>`,
    grossmg: `https://mstrprd.teic.techint.net/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=D530B471425C03319FCE7F936DEBC101&currentViewMedia=1&visMode=0&Server=TEIUYWAS132.TEIC.TECHINT.NET&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2021</pa><pa pt="3" pin="0" did="C00F8B74478126E3E8874BB2E8FC8FC0" tp="10">{COUNTRY}</pa></rsl>`,
    backlog: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/Backlog.pptx?web=1",
    acquisitions: `https://mstrprd.teic.techint.net/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=A1D692F94F9644D1B56F33A20F54F46F&currentViewMedia=1&visMode=0&Server=TEIUYWAS132.TEIC.TECHINT.NET&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="4" pin="0" did="89229A1E478528C5669C6A82E9A46114" tp="10">2021</pa><pa pt="3" pin="0" did="C00F8B74478126E3E8874BB2E8FC8FC0" tp="10">{COUNTRY}</pa></rsl>`,
    projects: `https://mstrprd.teic.techint.net/MicroStrategy/asp/Main.aspx?evt=2048001&src=Main.aspx.2048001&documentID=E47369F24CE7590B434B29BB66E8DF61&currentViewMedia=1&visMode=0&Server=TEIUYWAS132.TEIC.TECHINT.NET&Project=Economics&Port=0&share=1&hiddensections=header,path,dockTop,dockLeft,footer&share=1&promptsAnswerXML=<rsl><pa pt="3" pin="0" did="0526CBDA4A4905B8C4874995B6DE8918" tp="10">{REGION}</pa><pa pt="3" pin="0" did="C00F8B74478126E3E8874BB2E8FC8FC0" tp="10">{COUNTRY}</pa><pa pt="3" pin="0" did="F4C28419437AA78AA5E7B1A1755C0B53" tp="10">MAY 2021</pa></rsl>`,
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/CashFlow.pptx?web=1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202021/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
  },
  FEB2021: {
    pl: "6D481D7B4D421110C5C735A1DE39CD13",
    revenue: "202AA94C40C8ACC2EB3536A4CB1E30AC",
    grossmg: "80FF66CE46B6912BB1DDE7A84CB6CAAB",
    backlog: "E61D7F8E417D13CEB063C698CED56A48",
    acquisitions: "2DF1E6EB4A52651473FDD98D6127BCCA",
    projects: "84F3476C4CFE918D8B52848755F88030",
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202021/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202021/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202021/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202021/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202021/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202021/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202021/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202021/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/FEB21/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/FEB21/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/FEB21/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB21/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/FEB21/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/FEB21/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB21/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  JUN2020: {
    pl: "51E60D7948F18308C3829196ADDE6FA7",
    revenue: "0586402D45495A5B2A7E34A3C405AA78",
    grossmg: "5CA9F08446B44C3071112FA29D40D111",
    backlog: "53C3911342E0556C7B899BB33143F95D",
    acquisitions: "74F497524F4602545766398C822435AC",
    projects: "DBB1C9BB458AF53E59397A803D9BCE75",
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202020/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202020/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202020/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202020/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202020/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202020/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%2020/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202020/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/JUN20/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/JUN20/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/JUN20/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN20/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/JUN20/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/JUN20/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN20/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  FEB2020: {
    pl: "6D481D7B4D421110C5C735A1DE39CD13",
    revenue: "202AA94C40C8ACC2EB3536A4CB1E30AC",
    grossmg: "80FF66CE46B6912BB1DDE7A84CB6CAAB",
    backlog: "E61D7F8E417D13CEB063C698CED56A48",
    acquisitions: "2DF1E6EB4A52651473FDD98D6127BCCA",
    projects: "84F3476C4CFE918D8B52848755F88030",
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  JUL2019: {
    pl: "C1D8BD8F4966025C17385F87753627EE",
    revenue: "5D6AA3A847B0161A9416B19255EE0B35",
    grossmg: "0CFDAD374999AA6853F3DE9082B52258",
    backlog: "C8D21BBB420A2979DD4355B8DF8723F0",
    acquisitions: "0A8902834E9C0DB4E52EE68B2FF7E599",
    projects: "B4A26D9E4DA56BFE7C45DBBF20ABFB71",
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEBv2020/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202020/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB20/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  JUN2019: {
    pl: "56FB7C9046AE811925A0EF8B1C41E850",
    revenue: "E80A552D42CA5FB4772FD099C3A09EC2",
    grossmg: "79D359184CE3A1682FC3578F2427D182",
    backlog: "E61D7F8E417D13CEB063C698CED56A48",
    acquisitions: "5C93F4FA4B475CC03F0002B9F57EF338",
    projects: "09F6CF9945C317059FA6F785A67E800E",
    cashflow:
      "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  MAY2019: {
    pl: "6D481D7B4D421110C5C735A1DE39CD13",
    revenue: "202AA94C40C8ACC2EB3536A4CB1E30AC",
    grossmg: "80FF66CE46B6912BB1DDE7A84CB6CAAB",
    backlog: "E61D7F8E417D13CEB063C698CED56A48",
    acquisitions: "2DF1E6EB4A52651473FDD98D6127BCCA",
    projects: "21A6FEA5431CC2BFAE936DBAA339C55F",
    cashflow: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN%202019/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN2019/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },

  FEB2019: {
    pl: "6D481D7B4D421110C5C735A1DE39CD13",
    revenue: "202AA94C40C8ACC2EB3536A4CB1E30AC",
    grossmg: "80FF66CE46B6912BB1DDE7A84CB6CAAB",
    backlog: "E61D7F8E417D13CEB063C698CED56A48",
    acquisitions: "2DF1E6EB4A52651473FDD98D6127BCCA",
    projects: "25EE10034263E7CF3F1904AB4E791B7A",
    cashflow: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2019/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202019/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202019/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202019/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202019/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202019/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202019/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB%202019/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2019/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2019/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2019/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB2019/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2019/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/FEB2019/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB2019/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  NOV2018: {
    pl: "DC357AED48086C042C23CD84C82F3217",
    revenue: "DA373E5D46B74A5DD842EC9F6E622C0F",
    grossmg: "5869E7664B64B88863C790868E6C5571",
    backlog: "C8D21BBB420A2979DD4355B8DF8723F0",
    acquisitions: "C4A0A6214FB65694C2AE70846E749F10",
    projects: "016F765E4538FB5E192E1FB4B44B7348",
    cashflow: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV18/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  AGO2018: {
    pl: "DC357AED48086C042C23CD84C82F3217",
    revenue: "DA373E5D46B74A5DD842EC9F6E622C0F",
    grossmg: "5869E7664B64B88863C790868E6C5571",
    backlog: "C8D21BBB420A2979DD4355B8DF8723F0",
    acquisitions: "C4A0A6214FB65694C2AE70846E749F10",
    projects: "BC71231342FEF8A79E7840A5CC85D960",
    cashflow: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/AGO18/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  JUN2018: {
    pl: "9BF49C7741BA9C6352701BAA494DC735",
    revenue: "F8F8CF544BF27DD024C5288ADDE8AC14",
    grossmg: "646C462D47D956E725E48EA91C9F1CD9",
    backlog: "A5B1F6704FDED1E77B9B9A89CC8EF363",
    acquisitions: "0DCA42C641E3EA88F7FC7182926B3911",
    projects: "7C77EA2149C90253B41AD092C18E9F97",
    cashflow: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
  MAY2018: {
    pl: "6D481D7B4D421110C5C735A1DE39CD13",
    revenue: "202AA94C40C8ACC2EB3536A4CB1E30AC",
    grossmg: "80FF66CE46B6912BB1DDE7A84CB6CAAB",
    backlog: "E61D7F8E417D13CEB063C698CED56A48",
    acquisitions: "2DF1E6EB4A52651473FDD98D6127BCCA",
    projects: "88FBC93D4A38570996CF5F86220B19A2",
    cashflow: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/JUN18/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },

  FEB2018: {
    pl: "6D481D7B4D421110C5C735A1DE39CD13",
    revenue: "202AA94C40C8ACC2EB3536A4CB1E30AC",
    grossmg: "80FF66CE46B6912BB1DDE7A84CB6CAAB",
    backlog: "E61D7F8E417D13CEB063C698CED56A48",
    acquisitions: "2DF1E6EB4A52651473FDD98D6127BCCA",
    projects: "750972804D0FD2E1B90A5D9C8AC905BA",
    cashflow: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/CashFlow.pptx?web:1",
    attachments: {
      tepam: {
        label: "Tepam",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/TEPAM.pptx?web=1",
      },
      tepge: {
        label: "Tepge",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/TEPGE.pptx?web=1",
      },
      balance: {
        label: "Balance sheet",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/Balance.pptx?web=1",
      },
      inversiones: {
        label: "Inversiones",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/Inversiones.pptx?web=1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/OBMEJORA.pptx?web=1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/CONVIPE.pptx?web=1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/CONTIMP.pptx?web=1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   tepam: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/TEPAM.pptx?web:1",
    //   tepge: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/TEPGE.pptx?web:1",
    //   balance: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/Inversiones.pptx?web:1",
    //   omejoras: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/OBMEJORA.pptx?web:1",
    //   contvipe: "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/FEB18/OTS/CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },

  NOV2017: {
    pl: "DC357AED48086C042C23CD84C82F3217",
    revenue: "DA373E5D46B74A5DD842EC9F6E622C0F",
    grossmg: "5869E7664B64B88863C790868E6C5571",
    backlog: "C8D21BBB420A2979DD4355B8DF8723F0",
    acquisitions: "C4A0A6214FB65694C2AE70846E749F10",
    projects: "D65E965F40F5AA5DFF00B99379C761AC",
    attachments: {
      cashflow: {
        label: "cashflow",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - CashFlow.pptx?web:1",
      },
      tepam: {
        label: "Tepam",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - TEPAM.pptx?web:1",
      },
      tepge: {
        label: "Tepge",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - TEPGE.pptx?web:1",
      },
      balance: {
        label: "Balance sheet",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - Balance.pptx?web:1",
      },
      inversiones: {
        label: "Inversiones",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - Inversiones.pptx?web:1",
      },
      omejoras: {
        label: "Obj. Mejora",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - OBMEJORA.pptx?web:1",
      },
      contvipe: {
        label: "Conting. VIPE",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - CONVIPE.pptx?web:1",
      },
      contimprevistos: {
        label: "Cont. e Imprev.",
        url:
          "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - CONTIMP.pptx?web:1",
      },
      ofertas: {
        label: "Ofertas",
        url: "http://crm.teic.techint.net:82/",
      },
    },
    // attachments: {
    //   cashflow:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - CashFlow.pptx?web:1",
    //   tepam:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - TEPAM.pptx?web:1",
    //   tepge:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - TEPGE.pptx?web:1",
    //   balance:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - Balance.pptx?web:1",
    //   inversiones:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - Inversiones.pptx?web:1",
    //   omejoras:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - OBMEJORA.pptx?web:1",
    //   contvipe:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - CONVIPE.pptx?web:1",
    //   contimprevistos:
    //     "http://intra.teic.techint.net/sites/reporting/PRE/NOV17/OTS/PRE_OCT 2017 - CONTIMP.pptx?web:1",
    //   ofertas: "http://crm.teic.techint.net:82/",
    // },
  },
};

export default MEETINGS;
